import { createFileRoute } from '@tanstack/react-router';
import { ChartColumnIncreasing } from 'lucide-react';
import { ConsolidatedPerformance } from '@/components/performance/consolidated/consolidated-performance';
import { withOrgReset } from '@/components/glitch-ui/with-org-reset';

// The consolidated Performance page, offered as a beta from the bottom of the
// sidebar. The legacy per-tab page (Traffic/Cost/Looker) is the live /performance.
export const Route = createFileRoute('/_authenticated/_layout/performance-beta/')({
  component: withOrgReset(ConsolidatedPerformance),
  staticData: {
    title: 'Performance (Beta)',
    icon: ChartColumnIncreasing,
  },
});
